import { mainPath } from "../../../constants/access";

const nameTable = "agents";
const tPath = `${mainPath}.${nameTable}`;

export default tPath;
